import React from 'react'
import { connect } from 'react-redux'
import { Link} from "react-router-dom"
import './headerM.css'
import axios from 'axios'
import { withRouter } from 'react-router-dom'

import {userList} from '../../redux/chatuser.redux.js'
import {getInFoFn} from '../../redux/chatuser.redux.js'
@withRouter
@connect(
  state=>state.chatuser,
  {userList,getInFoFn}
) 
class HeaderM extends React.Component{
	constructor(props){
		super(props)
		this.state={
			
    	}
    	
	}
	componentDidMount(){
  		document.getElementById('meta1').setAttribute('content','心享俱乐部回归特权，游戏回归特权，回归特权礼包') 
  		document.getElementById('meta2').setAttribute('content','心享俱乐部全新推出游戏回归特权，心享俱乐部会员通过账号鉴定即可激活回归特权，独享特权包括回归礼包、高额返利、新游试玩等在内的游戏回归特权。') 
  	}
  	handleLogin(){		
		const pathname = this.props.location.pathname
		let pathtemp = pathname.split('/');
		pathtemp = pathtemp[pathtemp.length - 1];
		let loginurl = '/fapi/' + (pathtemp == 89 ? 'getLoginUrlSynthesize' : 'getLoginURL') + '?redirect_url=' + encodeURIComponent(encodeURIComponent(window.location.href));
		axios.get(loginurl)
	      .then(res=>{
	       	if(res.data.return_code==0){
	       		window.location.href = res.data.redirect_url
	 
	       	}
					     
		 })		
			
	}
	handleLogout(){		
		const MyOrigin = window.location.origin
		this.pathname = MyOrigin +''+ this.props.location.pathname
		
		window.location.href ="/fapi/logoutB?returnUrl="+encodeURIComponent(this.pathname)
	}
  	render(){
  		
  		return (

			<div className="header-m">
				<span className="logo-m"></span>
				{
					this.props.userlist.code===-1?<div className="login-m">
						<button onClick={()=>this.handleLogin()}></button>
					</div>:null
				
				}
				{
					this.props.userlist.displayAccount&&<div className="login-enter-m">
						<span>{this.props.userlist.displayAccount}</span>
						<button onClick={()=>this.handleLogout()}>注销</button>

					</div>

					
				}
			</div>
  		)
  	}
}

export default HeaderM




// WEBPACK FOOTER //
// ./src/component/headerM/headerM.js